module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/consulta/consulta.component.css
// module id = ./src/app/components/consulta/consulta.component.css
// module chunks = main